import PageStyle from "@/styles/components/share-cv/_index.module.scss";
import Button from "@/components/button";
import ButtonStyle from '@/styles/components/button/_index.module.scss';
import { CustomToastrAction, toastr } from "@/imports-files/common/common";


export class AutosuggestionInputAction
{
	constructor()
	{

    }

    // This function is used to fetch the dsuggestion of the data fron the api
    // Here name is the name of the hash which should be reterieve from data to show suggestion
    async onSuggestionsFetchRequested(value, setSuggestion, getSuggestionDataService, name, onFocusShowList)
    { 
      if(typeof value != 'undefined')
      {
        var suggestion = await this.getSuggestions(value, getSuggestionDataService, onFocusShowList);
        suggestion[name] ? setSuggestion(suggestion[name]) : setSuggestion([]);
      }
      else
      {
        setSuggestion([]);
      }
    }


    // Get Suggestion bring the session from the api
    // The api function will be pass through getSuggestion
    async getSuggestions(value, getSuggestionDataService, onFocusShowList=false)
    {

      let escapedValue = '';
      if(value?.value)
      {
         escapedValue = this.escapeRegexCharacters(value?.value?.trim());
      }

      if (escapedValue === '' && !onFocusShowList) 
      {
         return [];
      }
      // Calling the service function to provide data
      let result = await getSuggestionDataService(escapedValue);
      return result.data;
    }

    escapeRegexCharacters(str) 
    {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    // Functionality of this function ??
    getSuggestionValue(label)
    {
    	return label;
    }

    // This function will show the data in the dropdown 
    renderSuggestion(label)
    {
    	return (<div>{label}</div>)
    }

    // ------------------------------------------------------------ Used ------------------------------------------------------------



    // Clear the suggestion
    onSuggestionsClearRequested(setSuggestion)
    { 
    	setSuggestion([])
    }
     
    // Show the suggestion after user type more than 3 words 
    shouldRenderSuggestions(value, charLength)
    {
      // if(typeof value != 'undefined')
      // {
      //   return value.trim().length >= charLength;
      // }
      // else
      // {
      //   return true;
      // }
      return true;
    }
    

    // Add the add component in input text box for entering the data 
    renderInputComponent(inputProps, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, add_selected_value, params)
    { 
      // return(<div className="buttonIn ShareCV">
      return(<div className="buttonIn">
                <input  className   = {PageStyle.Form__Input} autoComplete="password"  {...inputProps} />
                {/* <Button buttonstyle = {`${ButtonStyle.nobgbutton} addbtn`} onClick={(event)=>{this.onAddClick(event, inputProps, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, add_selected_value, params)}}>Add</Button> */}
            </div>)
    };
    

    // Add the functionality of the add component in input text box for entering the data 
    onAddClick(event, value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, add_selected_value, params)
    {
      event.preventDefault();
      if(value.value?.trim() !='')
      {
        let new_value = {label: value.value, value: value.id||''}; 
        add_selected_value(new_value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params);
      }
    }


    // This function is called when click on the cross of the chips selected
    removeSelectedValues(event, selectedValues, setSelectedValues, setSelectedUserCount)
    {
      var selected_value_index = parseInt(event.currentTarget.getAttribute('data-index'));
      selectedValues.splice(selected_value_index,1);
      setSelectedValues(selectedValues);
      setSelectedUserCount(selectedValues.length)
    }


    // When selecting the suggestion 
    onSuggestionSelectionValue(value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, add_selected_value, params)
    {
      add_selected_value(value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params)
    }

    // Function called when pressing the enter key in the input
    handleKeyDown(evt, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, add_selected_value, params)
    {
      if (evt.key === 'Enter' && evt.target.value.trim() !='')  
      {
          evt.preventDefault();
          let value = {label: evt.target.value, value: evt.target.id};
          add_selected_value(value, setAutosuggestionFieldValue, selectedValues, setSelectedValues, formik, params);
      }
    }

  

}
